export default __webpack_public_path__ + "static/media/pexels-paula-anne-2498853.b5c6b76e.jpg";